import {defineStore} from 'pinia'

export const useHeaderBizSearchStore = defineStore('headerBizSearchStore', {
  state: _ => ({
    isSearchMode: false
  }),
  actions: {
    turnOnSearchMode () {
      this.isSearchMode = true
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/HeaderBizSearchStore.js